import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { getBrowserEnv } from "@/utils/tools";
import { ReactNode } from "react";

const ScrollContainer = ({ children }: { children: ReactNode }) => {
  const { isXPApp } = getBrowserEnv();
  const { navHeight } = useConfigPage();
  return (
    <div
      style={{
        height: isXPApp
          ? `calc(${window.innerHeight}px - ${navHeight}px)`
          : `${window.innerHeight}px`,
        overflow: "auto",
      }}
    >
      {children}
    </div>
  );
};

export default ScrollContainer;
